import { PageContainer } from "@/components/shared/page-container";
import { RouteError } from "@/components/shared/route-error";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(container)")({
    component: RouteComponent,
    errorComponent: () => <RouteError />,
});

function RouteComponent() {
    return (
        <PageContainer>
            <Outlet />
        </PageContainer>
    );
}
